module.exports = __webpack_public_path__ + "img/ROBOTARM_DT.77ffe140.png";